export { default as BannerWithGridLayoutDumb } from './banner-with-grid-layout-dumb';
